import { isBooleanTrue, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { addObjectToChildArrayAndRefreshCount, updateObjectInChildArrayAndRefreshCount, removeObjectFromChildArrayAndRefreshCount } from '../utils/dbUtils';
import { auth } from '../firebase';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
import Task from "./Task";

class TaskNote {
    id = uuid();
    body = '';
    by = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    at = moment().utc().toDate();

    constructor(taskNote) {
        if (isObjectNotEmpty(taskNote)) {
            if (isStringNotEmpty(taskNote.id)) { this.id = taskNote.id; }
            if (isStringNotEmpty(taskNote.body)) { this.body = taskNote.body; }
            if (isStringNotEmpty(taskNote.by)) { this.by = taskNote.by; }
            if (isNotNullOrUndefined(taskNote.at)) { this.at = taskNote.at; }
        }
    }

    toDto = () => {
        return {
            id: this.id,
            body: this.body,
            by: this.by,
            at: this.at
        };
    }

    static create = async (taskId, note) => {
        let newNote = new TaskNote(note).toDto();

        const success = await addObjectToChildArrayAndRefreshCount(Task.collectionName, taskId, 'notes', 'id', newNote, 'notesCount');
        if (isBooleanTrue(success)) {
            return newNote;
        }

        return null;
    }

    static update = async (taskId, note) => {
        let updatedNote = new TaskNote(note).toDto();

        const success = await updateObjectInChildArrayAndRefreshCount(Task.collectionName, taskId, 'notes', 'id', updatedNote, 'notesCount');
        if (isBooleanTrue(success)) {
            return updatedNote;
        }

        return null;
    }

    static remove = async (taskId, noteId) => {
        return await removeObjectFromChildArrayAndRefreshCount(Task.collectionName, taskId, 'notes', 'id', noteId, 'notesCount');
    }
}

export default TaskNote;